// Toggle Element functionality with Alpine.js
(() => {
    function registerToggleElement() {
        Alpine.data('toggleElement', () => ({
            toggleOn: false,

            toggle() {
                this.toggleOn = !this.toggleOn;
                const elementId = this.$el.dataset.elementId;
                const element = document.getElementById(elementId);

                if (element) {
                    element.classList.toggle('toggle-on');
                    document.body.classList.toggle('toggle-' + elementId);
                } else {
                    alert('Element with ID "' + elementId + '" not found.');
                }
            },
        }));
    }

    if (typeof Alpine !== 'undefined' && Alpine.version) {
        registerToggleElement();
    } else {
        document.addEventListener('alpine:init', () => {
            registerToggleElement();
        });
    }
})();

// Global event listener for loginModal:beforeOpen
document.addEventListener('loginModal:beforeOpen', function () {
    // Remove toggle-on class from all elements
    document.querySelectorAll('.toggle-on').forEach((el) => el.classList.remove('toggle-on'));

    // Remove 'on' class from all toggle buttons
    document
        .querySelectorAll('.toggle-element-button.on')
        .forEach((el) => el.classList.remove('on'));

    // Remove all toggle-* classes from body
    document.body.className = document.body.className.replace(/\btoggle-\S+/g, '');
});























